var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgOpened = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5V10.1492L3.91889 7.75061C4.29844 7.27618 4.87306 7 5.48063 7H13V5H8.86852H2ZM7.53518 3L6.12892 0.890599C5.75799 0.334202 5.13352 0 4.46482 0H2C0.89543 0 0 0.895431 0 2V3V5V12C0 13.1046 0.89543 14 2 14H3V13.9985C3.02668 13.9995 3.05356 14 3.08063 14H13.5194C14.1269 14 14.7016 13.7238 15.0811 13.2494L18.131 9.43704C18.9167 8.4549 18.2174 7 16.9597 7H15V5C15 3.89543 14.1046 3 13 3H7.53518ZM5.13148 3L4.46482 2H2V3H5.13148ZM15.9194 9H5.48063L3.08063 12H13.5194L15.9194 9Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpened, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/opened.ad9adaf9.svg";
export { ForwardRef as ReactComponent };